import * as React from 'react';
import { container } from './section-container.module.css';

const SectionContainer = ({children}) => {

    return (
        <div className = { container }>
            {children}
        </div>
    )
}

export default SectionContainer